import { useLocation, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { RoutePaths } from '../../routes/RoutePaths';
import { PositionEntity, JobsBoard } from '../../components';
import { StyledOpenPositionsPageWrap } from './OpenPositionsPage.styles';
import { useAppSelector } from '../../base';
import { organizationSelectors, jobsSelectors } from '../../actions';

const OpenPositionsPage = () => {
    const location = useLocation();
    const { id } = useParams();
    const path = location.pathname;
    const isEntityPath = path?.replace(/\/+$/, '') !== RoutePaths.positions;

    const companyInfo = useAppSelector(organizationSelectors.getCompanyInfo);
    const activeJob = useAppSelector(jobsSelectors.getActiveJob);
    
    const ogTitle = companyInfo?.name || 'Pargoda';
    const ogDescription = isEntityPath && activeJob?.title 
        ? activeJob.title 
        : companyInfo?.defaultLanguage === 'HE' 
            ? 'דף משרות'
            : 'Positions Page';
    const ogImage = companyInfo?.companyLogoUrl || '';

    return (
        <>
            <Helmet>
                <meta property="og:title" content={ogTitle} />
                <meta property="og:description" content={ogDescription} />
                {ogImage && <meta property="og:image" content={ogImage} />}
            </Helmet>
            {isEntityPath && <PositionEntity posotionId={id || '0'} />}
            <StyledOpenPositionsPageWrap isEntityPath={isEntityPath}>
                <JobsBoard />
            </StyledOpenPositionsPageWrap>
        </>
    );
};

export default OpenPositionsPage;
